<template>
  <table
    style="table-layout:fixed;margin:0 auto"
    align="center"
    bgcolor="#3f3f3f"
    border="0"
    cellpadding="0"
    cellspacing="0"
    width="100%"
  >
    <tr>
      <td class="wz" bgcolor="#3f3f3f" width="30"></td>
      <td>
        <table bgcolor="#3f3f3f" border="0" cellpadding="0" cellspacing="0">
          <tr>
            <td>
              <table align="left" bgcolor="#3f3f3f" border="0" cellpadding="0" cellspacing="0">
                <tr>
                  <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
                </tr>
                <tr>
                  <td class="mailingOptionsTD" style="color:#d5dbe6;font-family:sans-serif;font-size:12px;text-align:left;line-height:">
                    <a style="color: rgb(255, 255, 255);" href="/privacy-policy">{{ $t('confirmation.view.privacy_policy') }}</a> | {{ $t('confirmation.view.did_not_make') }}
                    <a href="mailto:info@skyparksecure.com?subject=False%20Booking" style="color: rgb(255, 255, 255);">
                      {{ $t('confirmation.view.click_here') }}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
                </tr>
                <tr>
                  <td class="mailingOptionsTD" style="color:#d5dbe6;font-family:sans-serif;font-size:12px;text-align:left;line-height:">
                    {{ $t('confirmation.view.copyright') }} &copy; 2002-{{ new Date().getFullYear() }} {{ company }}. - {{ $t('confirmation.view.rights_reserved') }}
                  </td>
                </tr>
                <tr>
                  <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
      <td class="wz" bgcolor="#3f3f3f" width="30"></td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "confirmation-view-header",
  props: {
    company: { type: String, default: 'SkyParkSecure Ltd' }
  }
};
</script>